module.exports = __webpack_public_path__ + "img/shipping.3f9e5dbe.png";